/* eslint-disable no-redeclare */
import type { z } from 'zod';

import { Integer } from './integer';

export const JourneyId = Integer;

export type JourneyId = z.infer<typeof JourneyId>;
